/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import * as Examples from './Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    a: "a",
    ul: "ul",
    li: "li",
    h3: "h3"
  }, _provideComponents(), props.components);
  if (!Examples) _missingMdxReference("Examples", false);
  if (!Examples.BasicSpan) _missingMdxReference("Examples.BasicSpan", true);
  if (!Examples.ResponsiveSpan) _missingMdxReference("Examples.ResponsiveSpan", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "Grid.Item"
      }), " is a building block for ", _jsx(_components.a, {
        href: "https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_grid_layout",
        children: "CSS grid"
      }), " based layout of contents and components. Should be used in combination with ", _jsx(_components.a, {
        href: "/uilib/layout/grid/container/",
        children: "Grid.Container"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["The columns do change based on what ", _jsx(_components.a, {
        href: "/uilib/usage/layout/media-queries/",
        children: "breakpoint"
      }), " the browser is in:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["4 columns when ", _jsx(_components.code, {
          children: "small"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["6 columns when ", _jsx(_components.code, {
          children: "medium"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["12 columns when ", _jsx(_components.code, {
          children: "large"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Span"
    }), "\n", _jsxs(_components.p, {
      children: ["You need to provide a ", _jsx(_components.code, {
        children: "span"
      }), " prop with a number from 1 to 12 (can be changed in ", _jsx(_components.a, {
        href: "/uilib/layout/grid/container/",
        children: "Grid.Container"
      }), " with the ", _jsx(_components.code, {
        children: "columns"
      }), " property)."]
    }), "\n", _jsx(_components.p, {
      children: "The span will be used to specify where the item is placed in the grid columns."
    }), "\n", _jsx(_components.p, {
      children: "A span needs always two numbers – from and to."
    }), "\n", _jsx(Examples.BasicSpan, {}), "\n", _jsx(_components.p, {
      children: "Example of spans:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "span={[1, 'end']}"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "span={{ small: [1, 4], medium: [1, 6], large: [1, 12]}}"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Responsive spans"
    }), "\n", _jsx(_components.p, {
      children: "You can also make spans respond to media queries."
    }), "\n", _jsxs(_components.p, {
      children: ["For doing so, provide a ", _jsx(_components.code, {
        children: "span"
      }), " prop with an object containing ", _jsx(_components.a, {
        href: "/uilib/usage/layout/media-queries/",
        children: "Media Query"
      }), " types. Each media size should contain a span, like mentioned above."]
    }), "\n", _jsx(Examples.ResponsiveSpan, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
